/* @flow weak */
import React from 'react';
import ReactDOM from 'react-dom';

import Input from 'components/Input.jsx';

class NumberInput extends React.Component {
  static propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number,
    ]),
  };

  state = {
    value: this.props.value || '',
  }

  getInputNode() {
    return ReactDOM.findDOMNode(this.refs.input);
  }

  handleChange(event) {
    let value = event.target.value.replace(/^(?!\d+\.?\d)$/, '');
    const values = value.split('.');

    if (values[1] && values[1].length > 2) {
      value = values[0] + '.' + values[1].substr(0, 2);
    }

    if (!isNaN(value)) {
      this.setState({ value });
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }

  render() {
    return (
      <Input
        {...this.props}
        ref="input"
        type="text"
        onChange={this.handleChange.bind(this)}
        value={this.state.value}
      />
    );
  }
}

export default NumberInput;



// WEBPACK FOOTER //
// ./src/components/NumberInput.jsx